import { useTranslation } from "react-i18next";
import InstructionsSection from "../../components/landingSections/InstructionsSection/InstructionsSection";
import AboutUsSection from "../../components/landingSections/aboutUsSection/AboutUsSection";
import BannerSection from "../../components/landingSections/bannerSection/BannerSection";
import CalculatorSection from "../../components/landingSections/calculatorSections/CalculatorSection";
import ContactSection from "../../components/landingSections/contactSection/ContactSection";
import FaqSection from "../../components/landingSections/faqSection/FaqSection";
import FirstSection from "../../components/landingSections/firstSection/FirstSection";
import FlightsSection from "../../components/landingSections/flightsSection/FlightsSection";
import ShopsSection from "../../components/landingSections/shopsSection/ShopsSection";
import WorkingHoursCard from "../../components/workinghours/WorkingHoursCard";

const Landing = ({ menuRefs }) => {
  return (
    <div>
      <FirstSection />
      <div className="flex flex-col gap-10 pb-10">
        <BannerSection />
        <div ref={menuRefs.aboutUs}>
          <AboutUsSection />
        </div>
        <FlightsSection />
        <CalculatorSection />
        <ShopsSection />
        {/* <InstructionsSection /> */}
        <FaqSection />
        <div ref={menuRefs.contact}>
          <ContactSection />
        </div>
        <WorkingHoursCard />
      </div>
    </div>
  );
};

export default Landing;
